module.exports = "/_next/static/images/Recovery@2x-3bb65a4336a27098b276622f835b9e9b.png";